import { render, staticRenderFns } from "./Update-Answer.vue?vue&type=template&id=1d02d203&scoped=true&"
import script from "./Update-Answer.vue?vue&type=script&lang=js&"
export * from "./Update-Answer.vue?vue&type=script&lang=js&"
import style0 from "./Update-Answer.vue?vue&type=style&index=0&id=1d02d203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d02d203",
  null
  
)

export default component.exports